import React from 'react'

import { useSelector } from 'react-redux';
import { InputLabel, Select, MenuItem, FormHelperText, SelectChangeEvent } from '@mui/material';

import { IState } from "../Interfaces/Common/IState";
import { AppState } from '../store/rootReducer';

interface StateSelectorProps {
  DefaultStateId: string;
  onChange: (id: string) => void;
  value: string;
  showLabel: boolean;
  helperText?: string;
  [p: string]: any; // remaining props
  labelText?: string;
  applicantAddressStateIdsToFilterBy?: string[]; // list of IDs to filter the list of applicant addresses to show in the dropdown
  fullWidth?: boolean;
}

const StateSelector: React.FC<StateSelectorProps> = (props) => {
  const states: IState[] = useSelector((state: AppState) => state.applications.states);
  const { DefaultStateId, onChange, value, id, showLabel, helperText, ...other } = props;

  const stateChanged = (event: SelectChangeEvent<string>, child: React.ReactNode) => {
    const val: string = event.target.value as string;
    onChange(val);
  }

  return (
    <>
      {showLabel ? <InputLabel >{props.labelText ? props.labelText : 'State'}</InputLabel> : null}
      <Select 
        name="stateSelector"
        value={value || ''} 
        defaultValue={DefaultStateId} 
        onChange={stateChanged}
        variant='standard'
        {...other}
        sx={{ minWidth: '165px' }}
        fullWidth={props.fullWidth}
      >
        <MenuItem>&nbsp;</MenuItem>
        {props.applicantAddressStateIdsToFilterBy && props.applicantAddressStateIdsToFilterBy.length > 0 
        ? states.filter(s => props.applicantAddressStateIdsToFilterBy?.includes(s.id)).map((state: IState) => <MenuItem key={state.id} value={state.id}>{state.name}</MenuItem>) 
        : states.map((state: IState) => <MenuItem key={state.id} value={state.id}>{state.name}</MenuItem>)}
      </Select>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </>
  )
}

export default StateSelector;
